// src/components/DashboardLayout.js

import React, { useState } from 'react';
import { useNavigate, useLocation, Outlet } from 'react-router-dom';
import { API_BASE_URL } from '../config';

import {
    Box, AppBar as MuiAppBar, Toolbar, IconButton, Drawer as MuiDrawer, List, ListItem,
    ListItemButton, ListItemIcon, ListItemText, Divider, Menu, MenuItem, CssBaseline,
    ThemeProvider, createTheme, styled, alpha, Tooltip, Avatar, Backdrop
} from '@mui/material';
import {
    Menu as MenuIcon,
    Logout,
    ArrowBack as ArrowBackIcon,
    ViewQuilt,
    Dashboard as DashboardIcon,
    Security // <<< MUDANÇA: Ícone importado
} from '@mui/icons-material';

// O restante do código permanece o mesmo...

const useAuth = () => ({
    user: { name: 'Usuário DMN', avatarUrl: null },
    logout: () => {
        localStorage.removeItem('arp_token');
        alert('Sessão encerrada!');
        window.location.href = '/';
    }
});

const theme = createTheme({
    palette: { primary: { main: '#ff834f' } },
    typography: { fontFamily: "'Inter', sans-serif" }
});

const StyledListItemButton = styled(ListItemButton)(({ theme }) => ({
    padding: '12px 24px',
    color: theme.palette.text.secondary,
    '&:hover': { backgroundColor: alpha(theme.palette.common.black, 0.04) },
    '&.Mui-selected': {
        backgroundColor: alpha(theme.palette.primary.main, 0.08),
        color: theme.palette.primary.main,
        fontWeight: 'bold',
        '&:hover': { backgroundColor: alpha(theme.palette.primary.main, 0.12) }
    },
}));

const DashboardLayout = () => {
    const [open, setOpen] = useState(false);
    const [anchorElProfile, setAnchorElProfile] = useState(null);
    const auth = useAuth();
    const navigate = useNavigate();
    const location = useLocation();

    // <<< MUDANÇA: Itens do menu atualizados
    const menuItems = [
        { text: 'Dashboard', icon: <DashboardIcon />, path: '/' },
        { text: 'Canvas Business Model', icon: <ViewQuilt />, path: '/canvases' },
        { text: 'Risk Map', icon: <Security />, path: '/riskmap' },
    ];

    const handleDrawerToggle = () => setOpen(!open);
    const handleDrawerClose = () => setOpen(false);
    const handleProfileMenuOpen = (event) => setAnchorElProfile(event.currentTarget);
    const handleProfileMenuClose = () => setAnchorElProfile(null);
    const handleLogout = () => {
        handleProfileMenuClose();
        auth.logout();
    };

    let avatarCompletoUrl = '';
    if (auth.user?.avatarUrl) {
        const imagePath = `/uploads/${auth.user.avatarUrl.replace(/\\/g, '/')}`;
        avatarCompletoUrl = new URL(imagePath, API_BASE_URL).href;
    }

    return (
        <ThemeProvider theme={theme}>
            <Box sx={{ display: 'flex' }}>
                <CssBaseline />
                <MuiAppBar
                    position="fixed"
                    elevation={0}
                    sx={{
                        zIndex: (theme) => theme.zIndex.drawer + 1,
                        backgroundColor: '#050a30',
                    }}
                >
                    <Toolbar>
                        <IconButton
                            aria-label="toggle drawer"
                            onClick={handleDrawerToggle}
                            edge="start"
                            sx={{ marginRight: 2, color: 'white' }}
                        >
                            <MenuIcon />
                        </IconButton>

                        <a href="/" style={{ display: 'flex', alignItems: 'center' }}>
                            <Box component="img" sx={{ height: 40 }} alt="Logo" src="/logonav.png" />
                        </a>
                        <Box sx={{ flexGrow: 1 }} />

                        <Tooltip title="Opções de Perfil">
                            <IconButton onClick={handleProfileMenuOpen} size="small">
                                <Avatar
                                    sx={{ width: 32, height: 32 }}
                                    src={avatarCompletoUrl}
                                >
                                    {auth.user?.name ? auth.user.name[0].toUpperCase() : 'U'}
                                </Avatar>
                            </IconButton>
                        </Tooltip>
                        <Menu anchorEl={anchorElProfile} open={Boolean(anchorElProfile)} onClose={handleProfileMenuClose}>
                            <MenuItem onClick={handleLogout}><ListItemIcon><Logout fontSize="small" /></ListItemIcon>Sair</MenuItem>
                        </Menu>
                    </Toolbar>
                </MuiAppBar>

                <MuiDrawer
                    anchor="left"
                    open={open}
                    onClose={handleDrawerClose}
                    variant="temporary"
                    ModalProps={{ keepMounted: true }}
                    sx={{ '& .MuiDrawer-paper': { boxSizing: 'border-box', width: 260 } }}
                >
                    <Toolbar />
                    <Box sx={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
                        <List>
                            {menuItems.map((item) => (
                                <ListItem key={item.text} disablePadding>
                                    <StyledListItemButton onClick={() => { navigate(item.path); handleDrawerClose(); }} selected={location.pathname === item.path}>
                                        <ListItemIcon>{item.icon}</ListItemIcon>
                                        <ListItemText primary={item.text} />
                                    </StyledListItemButton>
                                </ListItem>
                            ))}
                        </List>

                        <Box sx={{ flexGrow: 1 }} />

                        <Divider />
                        <List>
                            <ListItem disablePadding>
                                <StyledListItemButton onClick={() => window.location.href = 'https://cockpit.arpsoftware.com.br/'}>
                                    <ListItemIcon><ArrowBackIcon /></ListItemIcon>
                                    <ListItemText primary="Voltar à Plataforma" />
                                </StyledListItemButton>
                            </ListItem>
                        </List>
                    </Box>
                </MuiDrawer>

                <Backdrop
                  sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer - 1 }}
                  open={open}
                  onClick={handleDrawerClose}
                />

                <Box component="main" sx={{ flexGrow: 1, p: 3, width: '100%', minHeight: '100vh', bgcolor: '#f0f2f5' }}>
                    <Toolbar />
                    <Outlet />
                </Box>
            </Box>
        </ThemeProvider>
    );
};

export default DashboardLayout;
